import { StyleSheet } from 'react-native';
import CommonProperties, { expenseFieldHeight } from './CommonProperties';
import Color from './Color';
import { scaleVertically } from '../utils/scale.utils';

const box = {
  flex: 1,
  backgroundColor: 'white',
  ...CommonProperties.mx3,
  ...CommonProperties.my2,
  ...CommonProperties.borderRadius,
};

const baseExpenseCard = {
  backgroundColor: Color.accent,
  ...CommonProperties.borderRadius2,
  ...CommonProperties.shadow,
  justifyContent: 'center',
};

const CommonStyles = StyleSheet.create({
  ...CommonProperties,
  box: {
    ...box,
  },
  boxShadow: {
    ...box,
    ...CommonProperties.shadow,
  },
  flex1: {
    flex: 1,
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  disabledFormInput: {
    backgroundColor: Color.lightgray,
  },
  stepOneExpenseCard: {
    ...baseExpenseCard,
    height: expenseFieldHeight * 4,
  },
  stepTwoExpenseCard: {
    ...baseExpenseCard,
    marginTop: scaleVertically(14),
  },
  verticalDivider: {
    borderColor: Color.formDividerColor,
    borderRightWidth: 0.4,
    height: '100%',
  },
});

export default CommonStyles;
